/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
    PanelBody,
    SelectControl
} from '@wordpress/components';
import {
    useState,
    useEffect
} from '@wordpress/element';

import {VayuBlocksFlex, HeightControl} from '@vayu-blocks';

const ConatinerSettingPanel = ({
            attributes,
            setAttributes,
			openPanels, 
			onTogglePanel ,
            globalcontainerWidth}) => {

      // State to store the initial global container width
	  const [initialGlobalContainerWidth, setInitialGlobalContainerWidth] = useState(null);
	  // Set the initial value only once when the component mounts
	  useEffect(() => {
		  if (initialGlobalContainerWidth === null) {
			  setInitialGlobalContainerWidth(globalcontainerWidth);
		  }
	  }, [globalcontainerWidth, initialGlobalContainerWidth]);

      

    return (
      <>
       <PanelBody title={ __( 'Container', 'vayu-blocks' ) } 
       opened={openPanels['vb-conatiner-set']} onToggle={() => onTogglePanel('vb-conatiner-set')}>
                    <SelectControl
								label={ __( 'Content Width', 'vayu-blocks' ) }
								value={ attributes.contentWidthType }
								options={ [
									{ label:  __( 'Boxed', 'vayu-blocks' ), value: 'boxed' },
									{ label: __( 'Full Width', 'vayu-blocks' ), value: 'fullwidth' },
									{ label: __( 'Theme Default', 'vayu-blocks' ), value: 'alignwide' },
								] }
								onChange={ e => setAttributes({ contentWidthType: e }) }
					/>
                   { 'boxed' == attributes.contentWidthType && (
	
                        <HeightControl
                            label={__('Width', 'vayu-blocks')}
                            value={ attributes.boxedcontentWidth }
                            onChange={ (value) => setAttributes({boxedcontentWidth: value }) }
                            responsive={true}
                            customUnits={['px','%','em','vw']}
                            unitMax={{px:{max:2500, step:1}}}
                        />
                   )}
                   { 'fullwidth' == attributes.contentWidthType && (
                        <HeightControl
						label={__('Full Width', 'vayu-blocks')}
						value={attributes.fullcontentWidth}
                        onChange={ (value) => setAttributes({fullcontentWidth: value }) }
                        responsive={true}
                        customUnits={['px','%','em','vw']}
                        unitMax={{px:{max:2500, step:1}}}
					    />
                       )}
                       <HeightControl
						label={__('Height', 'vayu-blocks')}
						value={attributes.contentMinHgt}
                        onChange={ (value) => setAttributes({contentMinHgt: value }) }
                        responsive={true}
                        customUnits={['px','%','em','vh']}
					    />   
        </PanelBody>
		<PanelBody title={__('Flex', 'vayu-blocks')} opened={openPanels['vb-container-flex']} onToggle={() => onTogglePanel('vb-container-flex')} >
			<VayuBlocksFlex
			onChange={(key, value) => setAttributes({ [key]: value })}
			flex={{ key: 'contFlex', value: attributes.contFlex }}
		    />
		</PanelBody>
     </>
  );
};

export default ConatinerSettingPanel;